import { useEffect } from 'react';
import Axios from 'axios';
import { useRequest } from '@fuxi/eevee-hooks';
import { get } from 'lodash-es';

export function useDingZhi({ isMainVersion = true }: { isMainVersion?: boolean } = {}) {
  const { data, run, loading } = useRequest(
    () => {
      return Axios.get(`/dingzhi/get_dingzhi_json`);
    },
    { manual: true }
  );

  useEffect(() => {
    if (isMainVersion) return;
    // 考虑服务稳定性关闭定制功能
    // run();
  }, [isMainVersion, run]);

  const dingzhiJson = get(data, 'data.result.data', {});

  return {
    no_client_download_custom_list: get(dingzhiJson, 'no_client_download_custom_list', []) as string[],
    isGettingDingZhiConfig: loading,
    no_client_download_udm_custom_list: get(dingzhiJson, 'no_client_download_udm_custom_list', []) as string[],
  };
}
